import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { TitlePage } from 'components/atoms'
import CmsMediaCreateForm from 'domains/cms-media/create-form/cms-media-create-form'
import CmsMediaCardList from 'domains/cms-media/card-list/cms-media-card-list'
import CmsMediaApiV2 from 'api/v2/admins/cms-media-api-v2'
import { ALERT_TYPES } from 'constants/alert-constants'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CmsMediaCreatePage = ({ pageUtils }) => {
  const [ cmsMedia, setCmsMedia ]       = useState([])
  const [ pagination, setPagination ]   = useState({})
  const [ isSubmitted, setIsSubmitted ] = useState(false)
  const [ filters, setFilters ]         = useState({
    page     : 1,
    per_page : 8
  })

  useEffect(() => {
    CmsMediaApiV2.get({ params: filters })
      .then((response) => {
        setCmsMedia(response.data.media)
        setPagination(response.data.meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }, [ filters, isSubmitted ])

  const handleSubmitForm = async (values, actions) => {
    const payload = new FormData()
    const images  = values.images
    const key     = 'images[]'

    images.map((image) => {
      payload.append(key, image)
    })

    CmsMediaApiV2.create({ payload })
      .then(() => {
        pageUtils.setAlertMsg('Cms Media has been uploaded', ALERT_TYPES.SUCCESS)
        actions.resetForm()
        setIsSubmitted(!isSubmitted)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }

  const handleClickPage = (page) => {
    setFilters({
      ...filters,
      page: page
    })
  }

  return (
    <>
      <TitlePage mainTitle='Cms Media' />
      <CmsMediaCreateForm
        handleSubmitForm={ handleSubmitForm }
      />
      <CmsMediaCardList
        cmsMedia={ cmsMedia }
        onClickPage={ handleClickPage }
        pagination={ pagination }
      />
    </>
  )
}

CmsMediaCreatePage.propTypes    = propTypes
CmsMediaCreatePage.defaultProps = defaultProps

export default CmsMediaCreatePage
